"use client";

import { useEffect } from "react";
import useBookingStore from "@/store/booking-store";

export default function DeleteBooking() {
  const { resetBooking } = useBookingStore();

  useEffect(() => {
    resetBooking();
    useBookingStore.persist.clearStorage();
    sessionStorage.removeItem('wentToCheckout');
  }, []);

  return <></>;
}
